var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_1496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33325 4.16665C3.33325 3.94563 3.42105 3.73367 3.57733 3.57739C3.73361 3.42111 3.94557 3.33331 4.16659 3.33331H7.49992C7.72093 3.33331 7.93289 3.42111 8.08917 3.57739C8.24545 3.73367 8.33325 3.94563 8.33325 4.16665V7.49998C8.33325 7.72099 8.24545 7.93295 8.08917 8.08924C7.93289 8.24552 7.72093 8.33331 7.49992 8.33331H4.16659C3.94557 8.33331 3.73361 8.24552 3.57733 8.08924C3.42105 7.93295 3.33325 7.72099 3.33325 7.49998V4.16665Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.6667 4.16665C11.6667 3.94563 11.7545 3.73367 11.9108 3.57739C12.0671 3.42111 12.2791 3.33331 12.5001 3.33331H15.8334C16.0544 3.33331 16.2664 3.42111 16.4227 3.57739C16.579 3.73367 16.6667 3.94563 16.6667 4.16665V7.49998C16.6667 7.72099 16.579 7.93295 16.4227 8.08924C16.2664 8.24552 16.0544 8.33331 15.8334 8.33331H12.5001C12.2791 8.33331 12.0671 8.24552 11.9108 8.08924C11.7545 7.93295 11.6667 7.72099 11.6667 7.49998V4.16665Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.33325 12.5C3.33325 12.279 3.42105 12.067 3.57733 11.9108C3.73361 11.7545 3.94557 11.6667 4.16659 11.6667H7.49992C7.72093 11.6667 7.93289 11.7545 8.08917 11.9108C8.24545 12.067 8.33325 12.279 8.33325 12.5V15.8334C8.33325 16.0544 8.24545 16.2663 8.08917 16.4226C7.93289 16.5789 7.72093 16.6667 7.49992 16.6667H4.16659C3.94557 16.6667 3.73361 16.5789 3.57733 16.4226C3.42105 16.2663 3.33325 16.0544 3.33325 15.8334V12.5Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.6667 12.5C11.6667 12.279 11.7545 12.067 11.9108 11.9108C12.0671 11.7545 12.2791 11.6667 12.5001 11.6667H15.8334C16.0544 11.6667 16.2664 11.7545 16.4227 11.9108C16.579 12.067 16.6667 12.279 16.6667 12.5V15.8334C16.6667 16.0544 16.579 16.2663 16.4227 16.4226C16.2664 16.5789 16.0544 16.6667 15.8334 16.6667H12.5001C12.2791 16.6667 12.0671 16.5789 11.9108 16.4226C11.7545 16.2663 11.6667 16.0544 11.6667 15.8334V12.5Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardicon);
export default __webpack_public_path__ + "static/media/cardicon.01f546be50a145ab2376a2f6f461bb2a.svg";
export { ForwardRef as ReactComponent };